// React
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// View
import { FormCategoriesPlansPage } from './view';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';

// Containers Injections
import { useLoading } from '../../containers/hooksInjection';

// Helpers
import { APIClient } from '../../containers/helpers/helpersInjection';

// Redux
import {
  CategoryPlans,
  CreateCategoryPlans,
  UpdateCategoryPlans,
} from '../../../../store/actions';

const FormCategoriesPlans = () => {
  const [categoryPlan, setCategoryPlan] = useState({});

  const { id } = useParams();
  const api = new APIClient();
  const history = useHistory();
  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  const { categoryPlans, success, error } = useSelector((state) => ({
    categoryPlans: state.CategoryPlans.categoryPlans,
    success: state.CategoryPlans.success,
    error: state.CategoryPlans.error,
  }));

  const findCategoryPlan = async (id) => {
    if (categoryPlans) {
      const categoryFind = await api.get(`/register/plan-category/${id}`);

      if (categoryFind) {
        setCategoryPlan(categoryFind);
      }
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: categoryPlan.name ?? '',
      renovationInput: categoryPlan.contract_renewal ?? '',
      isOrganizations: categoryPlan.show_organization === 'f' ? false : true,
      isDetails: categoryPlan.show_employment_details === 'f' ? false : true,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      renovationInput: Yup.string().required(
        'Tempo de renovação é obrigatório'
      ),
      isOrganizations: Yup.boolean().nullable(),
      isDetails: Yup.boolean().nullable(),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        contract_renewal: values.renovationInput || null,
        show_organization: values.isOrganizations ? 't' : 'f',
        show_employment_details: values.isDetails ? 't' : 'f',
      };

      loadingWithTime(1000);
      if (categoryPlan.id) {
        dispatch(
          UpdateCategoryPlans({ id: categoryPlan.id, ...valuesToSubmit })
        );
        history.goBack();
      } else {
        history.goBack();
        dispatch(CreateCategoryPlans(valuesToSubmit));
      }
    },
  });

  useEffect(() => {
    dispatch(CategoryPlans());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      findCategoryPlan(id);
    }
  }, [id, categoryPlans]);

  return (
    <FormCategoriesPlansPage
      id={id}
      history={history}
      validation={validation}
    />
  );
};

export default FormCategoriesPlans;
